module.exports = __webpack_public_path__ + "static/media/dropper.fcaf6813.svg";